module.exports = __webpack_public_path__ + "img/nexultra-p-active-icon.b14a1a94.svg";